var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassHunter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.159 10.666h6.158l-6.158-10.666h-6.159z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.317 21.334-6.158-10.667h-6.159l6.159 10.667z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.238 26.667-3.079-5.333h-6.159l6.158 10.666h6.159l-3.08-5.333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.841 21.334h6.158l-6.158 10.666h-6.158z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16 10.666-6.158 10.667h-6.158l6.158-10.667z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12.921 5.333-3.08 5.333h-6.158l6.158-10.666h6.158l-3.079 5.333z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassHunter);
export default __webpack_public_path__ + "static/media/class-hunter.7f84b4ae4e20013990688499c4769a33.svg";
export { ForwardRef as ReactComponent };